import React from "react";
import HomeComponent from "../../features/home/HomeComponent";
const Home = () => {
  return <HomeComponent />;
};
export default Home;
